import { NgClass, NgStyle, NgTemplateOutlet } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButton } from '@angular/material/button';
import { MatOption } from '@angular/material/core';
import { MatDialog } from '@angular/material/dialog';
import { MatFormField, MatLabel, MatPrefix, MatSuffix } from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { MatInput } from '@angular/material/input';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { MatSelect } from '@angular/material/select';
import { CharityStore } from '@domains';
import { StoresService } from '@rspl-api';

import { FxFlexDirective, FxLayoutAlignDirective, FxLayoutDirective, FxLayoutGapDirective } from '../../flex-layout';
import { LookupComponent } from '../lookup.component';

@Component({
  selector: 'rspl-store-lookup',
  templateUrl: '../lookup.component.html',
  styleUrls: ['../lookup.component.scss'],
  imports: [
    MatFormField,
    NgClass,
    MatLabel,
    MatIcon,
    MatPrefix,
    NgStyle,
    MatProgressSpinner,
    MatSelect,
    FormsModule,
    ReactiveFormsModule,
    MatInput,
    MatSuffix,
    FxLayoutDirective,
    MatButton,
    MatOption,
    NgTemplateOutlet,
    FxLayoutAlignDirective,
    FxLayoutGapDirective,
    FxFlexDirective,
  ],
})
export class StoreLookupComponent extends LookupComponent<CharityStore> {
  constructor(
    protected override apiService: StoresService,
    protected override dialog: MatDialog,
  ) {
    super(apiService, dialog);
  }
}
